import React from "react";
import ReactDom from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import TopPresenter from "./presenter/top";
import GuidelinePresenter from "./presenter/guideline/guideline";
import CreatorsPresenter from "./presenter/creators/creators";
import StoryPresenter from "./presenter/story/story";
import GamePresenter from "./presenter/game/game";

function RedirectNotFound()
{
    window.location.href = '/404.html';
    return<></>
}

const App = () => {
    return(
        <>
            <Routes>
                {/* React化したページをここに追加する */}
                <Route path="/" element={<TopPresenter />}/>
                <Route path="/guideline/" element={<GuidelinePresenter />}/>
                <Route path="/creators/" element={<CreatorsPresenter />}/>
                <Route path="/story/" element={< StoryPresenter/>}/>
                <Route path="/game/" element={< GamePresenter/>}/>
                <Route path="*" element={<RedirectNotFound />}/>
            </Routes>
        </>
    );
}

const root = ReactDom.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/">
        <App />
    </BrowserRouter>
);